const styles = {
    button: {
        headerButton: {
            color: "im_mid_blue.500",
            paddingX: 2,
            fontSize: "15px",
            fontWeight: 500,
            lineHeight: "26px",
            letterSpacing: "0.46px",
            textTransform: "none",
        },
    },
    listIcon: {
        width: 18,
        height: 18,
    },
    listArrowIcon: {
        minWidth: "unset",
        marginLeft: "auto",
    },
    arrowDropDownIcon: {
        paddingRight: "unset",
        minWidth: "unset",
    },
    headerText: {
        marginRight: "auto",
    },
    menuList: (isOpen) => ({
        display: isOpen ? "block" : "none",
        backgroundColor: "white",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "4px",
    }),
    relativeDisplay: {
        position: "relative",
    },
};

export default styles;
